const { useConfigureInstall } = require('./src/shared/UseInstall')

exports.onClientEntry = () => {
  useConfigureInstall()
}

// Cuando se publica una version nueva, el service worker (modo offline) la descarga pero la pagina sigue con la vieja
// hasta la proxima navegacion: por eso hacia falta recargar 1 o 2 veces para ver los cambios, y quien entraba por un
// link de un mail corria el codigo viejo. Si la persona recien abrio la pagina (primeros segundos), se recarga sola para
// quedar en la version nueva. Pasado ese tiempo no se toca nada, para no cortar a alguien que esta comprando.
exports.onServiceWorkerUpdateReady = () => {
  try {
    if (typeof window !== 'undefined' && window.performance && window.performance.now() < 20000) {
      window.location.reload();
    }
  } catch (e) {
    // si falla, se actualiza en la proxima navegacion como siempre
  }
};
